import type { AuthCredentials } from '@/features/auth/login/api'

type AuthTranslator = (key: string) => string

// 浏览器原生 email 校验在不同语言环境下提示不可控，这里统一走 i18n。
const emailPattern = /^[\w.!#$%&'*+\-/=?^{|}~]+@([\w-]+\.)+[\w-]{2,}$/i

/**
 * 登录页字段级邮箱校验。
 * 返回已经本地化的错误文案；`undefined` 表示通过。
 */
export function validateEmailValue(value: string, t: AuthTranslator) {
  const trimmedValue = value.trim()

  if (!trimmedValue) {
    return t('common.validation.emailRequired')
  }

  if (!emailPattern.test(trimmedValue)) {
    return t('common.validation.emailInvalid')
  }

  return undefined
}

/**
 * 登录页字段级密码校验。
 * 这里只校验非空，密码强度由后端和重设密码流程负责。
 */
export function validatePasswordValue(value: string, t: AuthTranslator) {
  if (!value.trim()) {
    return t('common.validation.passwordRequired')
  }

  return undefined
}

/**
 * 提交前规范化 credentials。
 * 密码不 trim，避免用户真实密码首尾空格被前端偷偷改写。
 */
export function normalizeCredentials(values: AuthCredentials) {
  return {
    email: values.email.trim(),
    password: values.password,
  }
}
